import { memo } from 'react';

import { cx } from '@/utils/cx';

import styles from './MenuToggleButton.module.scss';

interface MenuToggleBarsProps {
  toggled: boolean;
}

/**
 * 세 줄 막대 (햄버거 ↔ X) 시각 구조.
 * Fragment 반환 — wrapper(button 또는 span)는 호출 측에서 제공.
 * shell/bar는 absolute로 배치되므로 자식 태그를 span으로 두어
 * 인라인 wrapper(MenuToggleIcon) 안에서도 HTML 유효.
 */
export const MenuToggleBars = memo(function MenuToggleBars({ toggled }: MenuToggleBarsProps) {
  return (
    <>
      <span className={cx(styles.shell, styles.shellTop, toggled && styles.toggled)}>
        <span className={cx(styles.bar, styles.barTop, toggled && styles.toggled)} />
      </span>
      <span className={cx(styles.shell, styles.shellMid, toggled && styles.toggled)}>
        <span className={styles.bar} />
      </span>
      <span className={cx(styles.shell, styles.shellBot, toggled && styles.toggled)}>
        <span className={cx(styles.bar, styles.barBot, toggled && styles.toggled)} />
      </span>
    </>
  );
});
